import * as actionTypes from "../actionTypes/Index";

import { Dispatch } from "react";
import { IActionType } from "../../interfaces/Index";
import {
  agentChatwootAssignmentApi,
  agentStoreAssignmentApi,
} from "redux/sources/AgentAssignmentSource";

export const agentChatwootAssignmentInit = () => ({
  type: actionTypes.AGENT_CHATWOOT_ASSIGNEMNT_INIT,
});

export const agentChatwootAssignmentSuccess = () => ({
  type: actionTypes.AGENT_CHATWOOT_ASSIGNMENT_SUCCESS,
});

export const agentChatwootAssignmentFailed = (
  error: string | object | null
) => ({
  type: actionTypes.AGENT_CHATWOOT_ASSIGNMENT_FAIL,
  error,
});

export const agentStoreAssignmentInit = () => ({
  type: actionTypes.AGENT_STORE_ASSIGNMENT_INIT,
});

export const agentStoreAssignmentSuccess = () => ({
  type: actionTypes.AGENT_STORE_ASSIGNMENT_SUCCESS,
});

export const agentStoreAssignmentFailed = (error: string | object | null) => ({
  type: actionTypes.AGENT_STORE_ASSIGNMENT_FAIL,
  error,
});

export const agentChatwootAssignment =
  (payload: FormData) => (dispatch: Dispatch<IActionType>) => {
    dispatch(agentChatwootAssignmentInit());
    return agentChatwootAssignmentApi(payload)
      .then((res) => dispatch(agentChatwootAssignmentSuccess()))
      .catch((e: object | null | string) =>
        dispatch(agentChatwootAssignmentFailed(e))
      );
  };

export const agentStoreAssignment =
  (payload: FormData) => (dispatch: Dispatch<IActionType>) => {
    dispatch(agentStoreAssignmentInit());
    return agentStoreAssignmentApi(payload)
      .then(() => dispatch(agentStoreAssignmentSuccess()))
      .catch((e: object | null | string) =>
        dispatch(agentStoreAssignmentFailed(e))
      );
  };
